import Cookies from 'js-cookie';
import $ from 'jquery';

const viewFacets = document.querySelector('.view-facets');
const facetsContainer = viewFacets ? viewFacets.querySelector('.view-facets__container') : null;
const facetsPosition = Cookies.get('facets-position');
const facetsOpen = Cookies.get('facets-open');
const showResults = window.location.search !== '';
const showFilters = Cookies.get('show-filters');
const formElement = document.querySelector('form[action^="/je-recherche/"]');
const sortBy = document.getElementById('edit-sort-by');
const whereTownInput = document.getElementById('edit-where-town');


const doToggle = (toggle) => {
  const elToggle = document.getElementById(toggle);
  const toggler = elToggle.dataset.facetsToggler;
  const toggling = elToggle.classList.contains(toggler);
  elToggle.classList.toggle(toggler, !toggling);
  document.body.classList.toggle('facets-open', !toggling);
  if (toggling) {
    Cookies.remove('facets-open');
    scrollToContainers();
  } else {
    Cookies.set('facets-open', 'true');
  }
}

// Scroll to formations/measures block
const scrollToContainer = (id) => {
  const container = document.getElementById(id);
  if (container) {
    document.documentElement.style.scrollBehavior = 'auto';
    if (window.matchMedia('(max-width: 1024px)').matches) {
      const topEl = document.querySelector('.top');
      window.scrollTo(0, container.offsetTop - topEl.clientHeight - 16);
    } else {
      const headerEl = document.querySelector('.header');
      window.scrollTo(0, container.offsetTop - headerEl.clientHeight - 16);
    }
    document.documentElement.style.scrollBehavior = '';
  }
}

const scrollToContainers = () => {
  scrollToContainer('mesures');
  scrollToContainer('formations');
  scrollToContainer('organismes');
  scrollToContainer('conseillers');
}

if (facetsPosition) {
  Cookies.remove('facets-position');
  setTimeout(() => {
    if (facetsOpen && window.matchMedia('(max-width: 1024px)').matches) {
      facetsContainer.scrollTop = parseInt(facetsPosition);
    }
  }, 1);
}

if (showFilters) {
  Cookies.remove('show-filters');
  scrollToContainer(formElement.id);
}

if (showResults && !showFilters && !facetsOpen) {
  scrollToContainers();
}


if (formElement) {
  formElement.addEventListener('submit', (e) => {

    //detect form submit on where town input
    if (whereTownInput && document.activeElement === whereTownInput && whereTownInput.value.length > 0) {
      const instance = $(whereTownInput).autocomplete('instance');
      const menu = instance.menu;
      const menuEl = menu.element;
      const item = $(menuEl).find('li').first();
      if ($(item).length > 0) {
        const editTownId = document.getElementById('edit-town-id');
        const editLocalisationValue = document.getElementById('edit-localisation-value');
        const data = $(item).data('uiAutocompleteItem');

        if (editTownId) {
          editTownId.value = data.entity_id;
        }
        if (editLocalisationValue) {
          editLocalisationValue.value = data.town_localisation;
        }
        whereTownInput.value = data.label;
      }
    }

    if (e.submitter && e.submitter.name === 'op') {
      Cookies.set('show-filters', 'true');
    }
  });

  if (sortBy) {
    sortBy.addEventListener('change', () => {
      formElement.submit();
    });
  }
}

if (facetsContainer) {
  // Open facets directly on mobile if it was already open
  if (facetsOpen && window.matchMedia('(max-width: 1024px)').matches) {
    doToggle('facets');
  } else {
    Cookies.remove('facets-open');
  }

  // toggle facets vanilla (to be faster than foundation toggler)
  const facetsToggles = viewFacets.querySelectorAll('button[data-facets-toggle]');
  facetsToggles.forEach((facetsToggle) => {
    facetsToggle.addEventListener('click', () => {
      const toggle = facetsToggle.dataset.facetsToggle;
      doToggle(toggle)
    });
  })

  // on facets input click add loading and save or clean cookie
  facetsContainer.addEventListener('click', (e) => {
    const target = e.target;
    if (target.tagName !== 'INPUT') return;

    if (window.matchMedia('(max-width: 1024px)').matches) {
      facetsContainer.classList.add('view-facets__container--loading');
      const position = facetsContainer.scrollTop;
      if (position > 0) {
        Cookies.set('facets-position', position.toString());
      }
    }
  });

  // Set is active on filter button
  const filtersBtn = viewFacets.querySelector('.button--filters');
  const facetsActive = facetsContainer.querySelectorAll('.block.facet-active');

  if (filtersBtn && facetsActive && facetsActive.length > 0) {
    filtersBtn.classList.add('is-active');
  }
}
